<script lang="ts" setup>
import { Slot } from "reka-ui";
import { computed, inject, ref } from "vue";
import { FORM_WARNING } from "./injectionKeys";
import { useFormField } from "./useFormField";

const { error, formItemId, formDescriptionId, formMessageId, formWarningId } = useFormField();

// Edited from shadcn-vue: a warning sets data-warning and joins aria-describedby.
const warning = inject(FORM_WARNING, ref(false));
const describedBy = computed(() =>
  [formDescriptionId, error.value && formMessageId, warning.value && formWarningId].filter(Boolean).join(" "),
);
</script>

<template>
  <Slot
    :id="formItemId"
    data-slot="form-control"
    :aria-describedby="describedBy"
    :aria-invalid="!!error"
    :data-warning="warning ? 'true' : undefined"
  >
    <slot />
  </Slot>
</template>
